import React from 'react';
import { FadeIn } from './Shared';
export const StatsBar = () => {
  return <div className="bg-navy-800 border-y border-navy-700 py-6" data-id="element-261">
      <div className="max-w-6xl mx-auto px-4" data-id="element-262">
        <FadeIn data-id="element-263">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x divide-navy-700" data-id="element-264">
            <div data-id="element-265">
              <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-266">
                +1.200
              </div>
              <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-267">
                familias
              </div>
            </div>
            <div data-id="element-268">
              <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-269">
                5
              </div>
              <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-270">
                Tomos
              </div>
            </div>
            <div data-id="element-271">
              <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-272">
                5
              </div>
              <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-273">
                Bonos
              </div>
            </div>
            <div data-id="element-274">
              <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-275">
                4.9/5
              </div>
              <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-276">
                ⭐⭐⭐⭐⭐
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </div>;
};